import { render, staticRenderFns } from "./piweb-submenu-item.vue?vue&type=template&id=16cb37e4&"
import script from "./piweb-submenu-item.vue?vue&type=script&lang=js&"
export * from "./piweb-submenu-item.vue?vue&type=script&lang=js&"
import style0 from "./piweb-submenu-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports